import type { JSX } from 'react';

import { alsEuro } from '../betrag';

/**
 * Der Hinweis auf einen Bruttobetrag, der nicht aufgeht (RND-18).
 *
 * ============================================================================
 * WARUM DIESER HINWEIS DEN BETRAG NENNEN MUSS
 * ============================================================================
 *
 * Nicht jeder Bruttobetrag lässt sich mit einem gegebenen Steuersatz in Netto
 * und Steuer zerlegen: Die Summe aus Netto und kaufmännisch gerundeter Steuer
 * springt beim Erhöhen des Nettos um einen Cent gelegentlich um zwei, und
 * dazwischen liegt eine Lücke. 3.200,00 € bei 19 % ist so ein Fall — der Beleg
 * weist 3.199,99 € aus.
 *
 * Bis zum 15.09.2026 stand hier ein Satz, der das FESTSTELLTE, ohne zu sagen,
 * welcher Betrag gemeint war und um wie viel er abweicht. Die Abnahme des
 * Firmenkundenprozesses hat es als Befund 4 aufgeschrieben: „Der Vertrieb
 * bietet einen Cent weniger an als vereinbart und erfährt den Grund nicht. Bei
 * einer Nachfrage des Kunden steht er ohne Erklärung da."
 *
 * Ein Hinweis, der nur auf etwas hinweist, ist kein Hinweis. Hier stehen
 * deshalb beide Beträge und die Abweichung — das ist genau die Auskunft, die
 * der Anwender dem Kunden am Telefon gibt.
 *
 * ============================================================================
 * EINE KOMPONENTE UND NICHT ZWEI TEXTE
 * ============================================================================
 *
 * Der Summenblock steht an der Angebots- und an der Auftragsakte, und derselbe
 * Sachverhalt muss an beiden gleich lauten. Zwei Texte liefen beim ersten
 * Nachbessern auseinander.
 */
export function Rundungshinweis({
  faelle,
}: {
  readonly faelle: readonly {
    readonly schluessel: string;
    readonly gewuenscht: string;
    readonly ausgewiesen: string;
    readonly abweichung: string;
  }[];
}): JSX.Element | null {
  if (faelle.length === 0) return null;

  return (
    <div className="warnung" role="note">
      <p>
        {faelle.length === 1
          ? 'Ein Bruttobetrag lässt sich mit seinem Steuersatz nicht genau in Netto und Steuer '
            + 'zerlegen. Ausgewiesen ist der nächstliegende darstellbare Betrag:'
          : `${String(faelle.length)} Bruttobeträge lassen sich mit ihrem Steuersatz nicht genau `
            + 'in Netto und Steuer zerlegen. Ausgewiesen ist jeweils der nächstliegende '
            + 'darstellbare Betrag:'}
      </p>
      <ul className="rundungshinweis">
        {faelle.map((f) => (
          <li key={`${f.schluessel}-${f.gewuenscht}`}>
            {f.schluessel}: <strong>{alsEuro(f.gewuenscht)}</strong> gewünscht, ausgewiesen{' '}
            <strong>{alsEuro(f.ausgewiesen)}</strong> — eine Abweichung von{' '}
            {alsEuro(f.abweichung)}.
          </li>
        ))}
      </ul>
    </div>
  );
}
